import { render, staticRenderFns } from "./UploadCertificate.vue?vue&type=template&id=df670cf4&"
import script from "./UploadCertificate.vue?vue&type=script&lang=js&"
export * from "./UploadCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports